import React from "react"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import { OverlayTrigger } from "react-bootstrap"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import dynamicFormTootip from "src/pages/dynamic_forms/Utils/DynamicFormTooltip"
import snackBar from "src/utilities/snackBar/SnackBar"
import "./NotFound.css"
import "../../DynamicForm.css"
interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function NotFound(props: Props) {

    // console.log("df_NotFoundField props", props)

    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"

    return (
        <div className={`DynamicForm${fieldType} DynamicFormNotFound${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>Empty Field</p>
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <OverlayTrigger placement="top" overlay={dynamicFormTootip("No configuration settings are available for an empty field.")}>
                            <span className="material-icons DynamicFormFieldHeaderRightSettingsDisabled"
                                style={{ color: `${paletteEngine.getPaletteColor("configDisabled")}` }}
                                onClick={() => snackBar({ text: "No configuration settings are available for an empty field.", type: "info", timeout: 5000 })}>
                                priority_high
                            </span>
                        </OverlayTrigger>
                        <TrashCan clickCallback={() => props.remove("Not Found", props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
        </div>
    )
}

export default NotFound